export interface CustomSelectOption {
	value: string
	label: string
	external?: boolean
	supportsExplore?: boolean
}

interface KeycloakEnvironment {
	host: string
	realm: string
	clientId: string
}
interface ContentfulEnvironment {
	space: string
	token: string
}
interface DatadogEnvironment {
	dd_trace: boolean
	client_token: string
	application_id: string
}
export interface Environment {
	root_domain: string
	contentful: ContentfulEnvironment
	keycloak: KeycloakEnvironment
	docker_version: string
	version?: string
	facebook_token?: string
	google_analytics_token?: string
	gtm_container_id?: string
	environment: string
	google_maps_key?: string
	enable_analytics: boolean
	datadog: DatadogEnvironment
	api_base: string
	commit_hash?: string
	build_number?: string
	short_version?: string
}

export enum CampaignIDs {
	BBM = 'BBM',
	BBMTU = 'BBM-TU',
	BBMTUR = 'BBM-TUR',
	JERRY = 'JERRY',
	MU30 = 'MU30',
	KIP = 'KIP',
	NOTRACK = 'notrack'
}

type mapped<T, K extends keyof T, V> = { [k in K]: V }

export type ConvertKeysToType<T, V> = mapped<T, keyof T, V>

export type VoidCallback = () => void
export type Callback<T> = (args: T) => void
